import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withHandlers } from 'recompose';
import { Button } from 'components/core/Button';

export const enhance = withHandlers({
	handleClick: (props) => () => props.onSelect(props.value),
});

export function DropdownOption({ handleClick, label, selected }) {
	return (
		<Button
			className={classnames('dropdown-option', { selected })}
			onClick={handleClick}
		>
			{label}
		</Button>
	);
}

DropdownOption.propTypes = {
	selected: PropTypes.bool,
	handleClick: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
};

export default enhance(DropdownOption);
